import React from 'react';
import type { BombiixIconProps } from './types';

/**
 * Bombiix Link icon — chain-link glyph (Figma node 4918:104765).
 * Uses `currentColor` so the parent element drives the tint.
 */
const LinkIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.8335 10.0005C2.8335 8.25159 4.25159 6.8335 6.00049 6.8335H7.3335C7.60964 6.8335 7.8335 7.05735 7.8335 7.3335C7.8335 7.60964 7.60964 7.8335 7.3335 7.8335H6.00049C4.80387 7.8335 3.8335 8.80387 3.8335 10.0005C3.83367 11.197 4.80398 12.1665 6.00049 12.1665H7.3335C7.60953 12.1665 7.83332 12.3905 7.8335 12.6665C7.8335 12.9426 7.60964 13.1665 7.3335 13.1665H6.00049C4.2517 13.1665 2.83367 11.7492 2.8335 10.0005ZM16.1665 10.0005C16.1665 8.80398 15.197 7.83367 14.0005 7.8335H12.6665C12.3905 7.83332 12.1665 7.60953 12.1665 7.3335C12.1665 7.05746 12.3905 6.83367 12.6665 6.8335H14.0005C15.7492 6.83367 17.1665 8.2517 17.1665 10.0005C17.1663 11.7491 15.7491 13.1663 14.0005 13.1665H12.6665C12.3905 13.1663 12.1665 12.9425 12.1665 12.6665C12.1667 12.3906 12.3906 12.1667 12.6665 12.1665H14.0005C15.1968 12.1663 16.1663 11.1968 16.1665 10.0005ZM12.6665 9.50049C12.9426 9.50049 13.1665 9.72435 13.1665 10.0005C13.1663 10.2765 12.9425 10.5005 12.6665 10.5005H7.3335C7.05746 10.5005 6.83367 10.2765 6.8335 10.0005C6.8335 9.72435 7.05735 9.50049 7.3335 9.50049H12.6665Z"
      fill="currentColor"
    />
  </svg>
);

export default LinkIcon;
